import script from "./AppLogoIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLogoIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppLogoIcon.vue?vue&type=style&index=0&id=4b6b7615&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6b7615"]])

export default __exports__